module.exports = __webpack_public_path__ + "static/media/sunrise.086ad671.svg";